import { connect } from 'react-redux'
import TeamPage from './team-page'
import { config } from '../../../redux/selectors'
import { withRouter } from 'react-router-dom'

const mapState = (state, ownProps) => {
  return {
    config: config(state),
    ...ownProps,
  }
}

const mapDispatch = dispatch => {
  return {}
}

export default withRouter(connect(mapState, mapDispatch)(TeamPage))



// WEBPACK FOOTER //
// ./src/components/views/team-page/team-page.connect.js